import StatusBadge from 'components/atoms/status-badge'
import { LIVE_PROCESS_STATUS } from 'domains/seller-product/constants'
import PropTypes from 'prop-types'
import React from 'react'

const proptypes = {
  live_process_status: PropTypes.string
}

/**
 * To give nice look on Seller Product `live_process_status`.
 * It maps `live_process_status` to certain style and pass to `StatusBadge`.
 * @param {string} live_process_status Seller Product live process status. available values
 * - `pending`
 * - `ready_live`
 * - `completed`
 * - `disabled`
 */
const SellerProductLiveProcessStatusBadge = ({ live_process_status }) => {

  const colorMap = {
    [LIVE_PROCESS_STATUS.PENDING]    : 'warning',
    [LIVE_PROCESS_STATUS.READY_LIVE] : 'info',
    [LIVE_PROCESS_STATUS.COMPLETED]  : 'success',
    [LIVE_PROCESS_STATUS.DISABLED]   : 'danger'
  }

  const color = colorMap[live_process_status] || 'default'

  return <StatusBadge color={ color } label={ live_process_status } />
}

SellerProductLiveProcessStatusBadge.propTypes = proptypes

export default SellerProductLiveProcessStatusBadge
